import React, { useState, useCallback, useMemo } from 'react'
import { SuperpowersContext } from './SuperpowersContextDef'

const STORAGE_KEY = 'bandos_superpowers'

function loadFromStorage(): { disablePortraitGeneration: boolean } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) return JSON.parse(raw) as { disablePortraitGeneration: boolean }
  } catch {
    // ignore
  }
  return { disablePortraitGeneration: false }
}

export const SuperpowersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [disablePortraitGeneration, setDisablePortraitGenerationState] = useState(
    () => loadFromStorage().disablePortraitGeneration
  )

  const setDisablePortraitGeneration = useCallback((val: boolean) => {
    setDisablePortraitGenerationState(val)
    try {
      const current = loadFromStorage()
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ ...current, disablePortraitGeneration: val })
      )
    } catch {
      // ignore
    }
  }, [])

  const contextValue = useMemo(
    () => ({ disablePortraitGeneration, setDisablePortraitGeneration }),
    [disablePortraitGeneration, setDisablePortraitGeneration]
  )

  return <SuperpowersContext.Provider value={contextValue}>{children}</SuperpowersContext.Provider>
}
